"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PercentMysqlHandler", {
    enumerable: true,
    get: function() {
        return PercentMysqlHandler;
    }
});
const _decimalmysqlhandler = require("~/db/field-handler/handlers/decimal/decimal.mysql.handler");
let PercentMysqlHandler = class PercentMysqlHandler extends _decimalmysqlhandler.DecimalMysqlHandler {
};
